export default __webpack_public_path__ + "static/media/gnd_kr_rudl_a2.d8aba5c7.mp3";